<template>
  <div>
    <b-breadcrumb :items="[{text: 'All Notifications', to: `/alerts/${alert_category}`}, {text: 'Notification', active: true}]"/>
    <loading :loading="isLoading" :message="`Loading '${alert_category}' for ${address}`">
      <div v-if="page">
        <policy-definition :category="alert_category" :reference="reference" :status="page.CaseStatus[0].status" :misnomers="page.IsMisnomer"/>
        <under-investigation :casenotes="caseNotes" :category="alert_category" :reference="reference"/>
        <policy-details :category="alert_category" :reference="reference"/>
      </div>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import UnderInvestigation from '../components/UnderInvestigation.vue'
import PolicyDefinition from '../components/PolicyDefinition.vue'
import PolicyDetails from '../components/PolicyDetails.vue'

export default {
  components: { Loading, UnderInvestigation, PolicyDefinition, PolicyDetails },
  data() {
    return {
      ...this.$route.params,
      isLoading: true,
      caseNotes: null,
      error: null,
      page: null,
    };
  },
  computed: {
    address() {
      return this.reference.replace('|', ', ');
    }
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'AbstractNotification',
      parameters: {
        category: this.alert_category,
        reference: this.reference,
      },
    })
    .then((page) => {
      this.page = page;
      this.caseNotes = page.Investigation.length > 0 ? this.caseNotes = this.page.Investigation[0] : null;
      this.isLoading = false;
    })
    .catch((e) => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
